'use strict';
var moduleCodes = require('../constants/moduleCodes');
var ModulePath = require('../constants/modulePath');
var adminPath = ModulePath[moduleCodes.MODULE_ADMIN];

var RoutePath = require('../constants/routePath');

exports.getAdminModuleUrl = () => `/${adminPath}`;
exports.getOrganisationUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_ORGANISATIONS}`;
exports.getModulesUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_MODULES}`;
exports.getAdminBooksSubscriptionUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_BOOKS_SUBSCRIPTION}`;
exports.getAdminInspectionCoachUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_INSPECTION_COACH}`;
exports.getAdminQuestionnairesUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_QUESTIONNAIRES}`;
exports.getAdminFrameworksUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_FRAMEWORKS}`;
exports.getAdminObservationNotesUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_OBSERVATION_NOTES}`;
exports.getAdminObservationObjectivesUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_OBSERVATION_OBJECTIVES}`;
exports.getAdminReportTemplates = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_REPORT_TEMPLATES}`;
exports.getAdminAssessment = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_ASSESSMENT}`;
exports.getAdminParentShare = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_PARENT_SHARE}`;
exports.getAdminUploadFrameworksUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_UPLOAD_FRAMEWORKS}`;
exports.getAdmin2bapSettings = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_2BAP_SETTINGS}`;
exports.getAdminSectorAreasUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_SECTOR_AREAS}`;
exports.getActivityLogUrl = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_ACTIVITY_LOG}`;
exports.getConfigurePlans = () => `/${adminPath}/${RoutePath.ROUTE_ADMIN_CONFIGURE_PLANS}`;
exports.getMyProfileUrl = () => `/${adminPath}/${RoutePath.ROUTE_MY_PROFILE}`;
